@if (isDesktopLayout) {
  <app-tenant-shell>
    <router-outlet></router-outlet>
  </app-tenant-shell>
} @else {
  <app-mobile-shell>
    <router-outlet></router-outlet>
  </app-mobile-shell>
}
